import { Checkbox } from 'antd'
import { Rule } from 'antd/lib/form'

import { CheckboxCaptureBlock as CheckboxCaptureBlockType } from '../../types/blueprint'

import { CaptureBlockFormItem } from './CaptureBlockFormItem'

type Props = {
  block: CheckboxCaptureBlockType
  rules: Rule[]
}

export const CheckboxCaptureBlock: React.FC<Props> = ({ block, rules }) => {
  const { checkboxes = [] } = block

  const defaultChecked = checkboxes
    .filter((checkbox) => checkbox.checked)
    .map((checkbox) => checkbox.value)

  return (
    <CaptureBlockFormItem
      block={block}
      initialValue={defaultChecked}
      rules={rules}
    >
      <Checkbox.Group style={{ width: '100%' }}>
        {checkboxes.map((checkbox, i) => {
          return (
            <div key={i + checkbox.value}>
              <Checkbox value={checkbox.value}>{checkbox.label}</Checkbox>
            </div>
          )
        })}
      </Checkbox.Group>
    </CaptureBlockFormItem>
  )
}
